"use strict";
(self["webpackChunkshoptrade_Shopify_Development"] = self["webpackChunkshoptrade_Shopify_Development"] || []).push([["shared"],{

/***/ "./js/components/shopify-cart-operations.js":
/*!**************************************************!*\
  !*** ./js/components/shopify-cart-operations.js ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/asyncToGenerator */ "./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js");

/**
 * Shopify Cart Operations Utility
 * Provides centralized cart operations with callback-based approach
 */

class ShopifyCartOperations {
  constructor() {
    this.baseUrl = '';
    this.headers = {
      'Content-Type': 'application/json'
    };
  }

  /**
   * Fetch current cart data
   * @param {Function} onSuccess - Callback function called with cart data
   * @param {Function} onError - Callback function called with error
   */
  fetchCart(onSuccess, onError) {
    var _this = this;
    return (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* () {
      try {
        var response = yield fetch('/cart.js');
        if (!response.ok) {
          throw new Error("Failed to fetch cart: ".concat(response.status, " ").concat(response.statusText));
        }
        var cart = yield response.json();
        window.cartToken = cart.token;

        // Auto-remove orphaned appointment products after fetching fresh cart data
        try {
          console.log('Running auto-removal on cart fetch...');
          yield _this.autoRemoveOrphanedAppointments(cart.items);
        } catch (orphanError) {
          console.warn('Error auto-removing orphaned appointments:', orphanError);
          // Don't fail the main operation if orphan removal fails
        }

        // Clear conflicting consultation form data based on current cart state
        try {
          console.log('Clearing conflicting consultation form data...');
          // this.clearConflictingConsultationFormDataFromCart(cart.items);
        } catch (formClearError) {
          console.warn('Error clearing conflicting consultation form data:', formClearError);
          // Don't fail the main operation if form clearing fails
        }
        if (onSuccess) {
          onSuccess(cart);
        }
        return cart;
      } catch (error) {
        console.error('Error fetching cart:', error);
        if (onError) {
          onError(error);
        }
        throw error;
      }
    })();
  }

  /**
   * Add items to cart
   * @param {Array} items - Array of items to add
   * @param {Function} onSuccess - Callback function called with response
   * @param {Function} onError - Callback function called with error
   */
  addToCart(items, onSuccess, onError) {
    var _this2 = this;
    return (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* () {
      try {
        // Check if any of the items being added are dummy consultation products
        // and if a dummy consultation already exists in cart
        var dummyConsultationExists = yield _this2.checkDummyConsultationInCart();

        // if (dummyConsultationExists) {
        //   console.log('Dummy consultation already exists in cart, skipping add operation');

        //   // Still call success callback but with a message
        //   if (onSuccess) {
        //     onSuccess({ 
        //       message: 'Dummy consultation already exists in cart',
        //       skipped: true 
        //     });
        //   }
        //   return { message: 'Dummy consultation already exists in cart', skipped: true };
        // }

        var response = yield fetch('/cart/add.js', {
          method: 'POST',
          headers: _this2.headers,
          body: JSON.stringify({
            items
          })
        });
        if (!response.ok) {
          var errorData = yield response.json().catch(() => ({}));
          throw new Error(errorData.description || "Failed to add to cart: ".concat(response.status, " ").concat(response.statusText));
        }
        var result = yield response.json();

        // Update cart header count after adding items to cart
        _this2.updateCartItemsClasses(result);
        console.log('Cart header count updated after adding items to cart');

        // Trigger pubsub cart update event for adding items (same as updateCartItem)
        if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'cart-items'
          });
        }

        // Also trigger DOM cart update event
        var cartUpdateEvent = new CustomEvent('cartUpdate', {
          detail: {
            cart: result,
            source: 'shopify-cart-operations',
            timestamp: new Date().toISOString()
          }
        });
        document.dispatchEvent(cartUpdateEvent);
        if (onSuccess) {
          onSuccess(result);
        }
        return result;
      } catch (error) {
        console.error('Error adding to cart:', error);
        if (onError) {
          onError(error);
        }
        throw error;
      }
    })();
  }

  /**
   * Update cart item quantity
   * @param {string} itemKey - Cart item key
   * @param {number} quantity - New quantity (0 to remove)
   * @param {Function} onSuccess - Callback function called with response
   * @param {Function} onError - Callback function called with error
   */
  updateCartItem(itemKey, quantity, onSuccess, onError) {
    var _this3 = this;
    return (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* () {
      try {
        var response = yield fetch('/cart/change.js', {
          method: 'POST',
          headers: _this3.headers,
          body: JSON.stringify({
            id: itemKey,
            quantity: quantity
          })
        });
        if (!response.ok) {
          return;
        }
        var result = yield response.json();

        // Update cart header count after updating cart item
        _this3.updateCartItemsClasses(result);
        console.log('Cart header count updated after updating cart item');

        // Trigger pubsub cart update event for consultation product removal (same source as delete button)
        if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'cart-items'
          });
        }
        if (onSuccess) {
          onSuccess(result);
        }
        return result;
      } catch (error) {
        console.error('Error updating cart item:', error);
        if (onError) {
          onError(error);
        }
        throw error;
      }
    })();
  }

  /**
   * Update cart item properties
   * @param {string} itemKey - Cart item key
   * @param {Object} properties - Properties to update
   * @param {Function} onSuccess - Callback function called with response
   * @param {Function} onError - Callback function called with error
   */
  updateCartItemProperties(itemKey, properties, onSuccess, onError) {
    var _this4 = this;
    return (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* () {
      try {
        var response = yield fetch('/cart/change.js', {
          method: 'POST',
          headers: _this4.headers,
          body: JSON.stringify({
            id: itemKey,
            properties: properties
          })
        });
        if (!response.ok) {
          var errorData = yield response.json().catch(() => ({}));
          throw new Error(errorData.description || "Failed to update cart item properties: ".concat(response.status, " ").concat(response.statusText));
        }
        var result = yield response.json();

        // Update cart header count after updating cart item properties
        _this4.updateCartItemsClasses(result);
        console.log('Cart header count updated after updating cart item properties');
        if (onSuccess) {
          onSuccess(result);
        }
        return result;
      } catch (error) {
        console.error('Error updating cart item properties:', error);
        if (onError) {
          onError(error);
        }
        throw error;
      }
    })();
  }

  /**
   * Remove item from cart
   * @param {string} itemKey - Cart item key
   * @param {Function} onSuccess - Callback function called with response
   * @param {Function} onError - Callback function called with error
   */
  removeFromCart(itemKey, onSuccess, onError) {
    var _this5 = this;
    return (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* () {
      console.log("=== REMOVE FROM CART CALLED for itemKey: ".concat(itemKey, " ==="));
      try {
        var result = yield _this5.updateCartItem(itemKey, 0, onSuccess, onError);
        return result;
      } catch (error) {
        console.error('Error in removeFromCart:', error);
        if (onError) onError(error);
        throw error;
      }
    })();
  }

  /**
   * Clear entire cart
   * @param {Function} onSuccess - Callback function called with response
   * @param {Function} onError - Callback function called with error
   */
  clearCart(onSuccess, onError) {
    var _this6 = this;
    return (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* () {
      try {
        var cart = yield _this6.fetchCart();
        if (cart.items.length === 0) {
          if (onSuccess) {
            onSuccess({
              items: []
            });
          }
          return {
            items: []
          };
        }

        // Remove all items by setting quantity to 0
        var removePromises = cart.items.map(item => _this6.updateCartItem(item.key, 0));
        yield Promise.all(removePromises);

        // Update cart header count after clearing cart
        _this6.updateCartItemsClasses({
          items: []
        });
        console.log('Cart header count updated after clearing cart');

        // Clear appointment data when cart is cleared
        if (window.clearAppointmentDataIfNeeded) {
          window.clearAppointmentDataIfNeeded([], 0);
        }
        if (onSuccess) {
          onSuccess({
            items: []
          });
        }
        return {
          items: []
        };
      } catch (error) {
        console.error('Error clearing cart:', error);
        if (onError) {
          onError(error);
        }
        throw error;
      }
    })();
  }

  /**
   * Update cart note/attributes
   * @param {Object} attributes - Cart attributes to update
   * @param {Function} onSuccess - Callback function called with response
   * @param {Function} onError - Callback function called with error
   */
  updateCartAttributes(attributes, onSuccess, onError) {
    var _this7 = this;
    return (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* () {
      try {
        var response = yield fetch('/cart/update.js', {
          method: 'POST',
          headers: _this7.headers,
          body: JSON.stringify({
            attributes
          })
        });
        if (!response.ok) {
          var errorData = yield response.json().catch(() => ({}));
          throw new Error(errorData.description || "Failed to update cart attributes: ".concat(response.status, " ").concat(response.statusText));
        }
        var result = yield response.json();
        if (onSuccess) {
          onSuccess(result);
        }
        return result;
      } catch (error) {
        console.error('Error updating cart attributes:', error);
        if (onError) {
          onError(error);
        }
        throw error;
      }
    })();
  }

  /**
   * Check if item exists in cart
   * @param {string|number} variantId - Variant ID to check
   * @param {string|number} productId - Product ID to check (optional)
   * @param {Function} onSuccess - Callback function called with result
   * @param {Function} onError - Callback function called with error
   */
  checkItemInCart(variantId) {
    var _arguments = arguments,
      _this8 = this;
    return (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* () {
      var productId = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : null;
      var onSuccess = _arguments.length > 2 ? _arguments[2] : undefined;
      var onError = _arguments.length > 3 ? _arguments[3] : undefined;
      try {
        var cart = yield _this8.fetchCart();
        var existingItem = cart.items.find(item => {
          var variantMatch = item.variant_id.toString() === variantId.toString();
          var productMatch = productId ? item.product_id.toString() === productId.toString() : true;
          return variantMatch && productMatch;
        });
        var result = {
          exists: !!existingItem,
          item: existingItem || null
        };
        if (onSuccess) {
          onSuccess(result);
        }
        return result;
      } catch (error) {
        console.error('Error checking item in cart:', error);
        if (onError) {
          onError(error);
        }
        throw error;
      }
    })();
  }

  /**
   * Refresh cart section using Shopify's section rendering API
   * @param {string} sectionId - Section ID to refresh
   * @param {Function} onSuccess - Callback function called with success
   * @param {Function} onError - Callback function called with error
   */
  refreshCartSection(sectionId, onSuccess, onError) {
    var _this9 = this;
    return (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* () {
      try {
        console.log("Attempting to refresh cart section: ".concat(sectionId));

        // Check if section exists in DOM before attempting to refresh
        var currentSection = document.querySelector("#".concat(sectionId));
        if (!currentSection) {
          console.warn("Section ".concat(sectionId, " not found in DOM, skipping refresh"));
          if (onSuccess) onSuccess(false);
          return false;
        }
        var response = yield fetch("?section_id=".concat(sectionId));
        if (!response.ok) {
          throw new Error("Failed to refresh cart section: ".concat(response.status, " ").concat(response.statusText));
        }
        var sectionHtml = yield response.text();
        var parser = new DOMParser();
        var sectionDoc = parser.parseFromString(sectionHtml, 'text/html');
        var newSection = sectionDoc.querySelector("#".concat(sectionId));
        if (newSection) {
          currentSection.innerHTML = newSection.innerHTML;
          console.log("Successfully refreshed cart section: ".concat(sectionId));

          // After refreshing cart sections, ensure product badges are properly displayed
          if (sectionId === 'main-cart-items' || sectionId === 'cart-items') {
            _this9.ensureProductBadgesDisplay();
          }

          // Cart sections are already updated with proper currency formatting from server
          // No need to manually update subtotal price as it's handled by the section refresh
        } else {
          console.warn("New section content not found for: ".concat(sectionId));
        }

        // Note: Cart header count is updated in performCartRefresh to avoid duplicate updates

        if (onSuccess) {
          onSuccess(true);
        }
        return true;
      } catch (error) {
        console.error("Error refreshing cart section ".concat(sectionId, ":"), error);
        if (onError) {
          onError(error);
        }
        throw error;
      }
    })();
  }

  /**
   * Ensure product badges are properly displayed in cart items
   * This method checks and adds badges for pharmacy and prescription products
   */
  ensureProductBadgesDisplay() {
    try {
      // Get all cart items
      var cartItems = document.querySelectorAll('.cart-item');
      cartItems.forEach((cartItem, index) => {
        // Check if badges already exist
        var existingBadges = cartItem.querySelectorAll('.badge--pharmacy, .badge--prescription');
        if (existingBadges.length > 0) {
          return; // Badges already exist, skip
        }

        // Get product type from data attribute or try to infer from product info
        var productTypeElement = cartItem.querySelector('.cart-item__name');
        if (!productTypeElement) return;

        // Try to get product type from various sources
        var productType = null;

        // Check if there's a data attribute with product type
        var productTypeData = cartItem.getAttribute('data-product-type');
        if (productTypeData) {
          productType = productTypeData;
        } else {
          var _productTypeElement$c;
          // Try to get from product title or other elements
          var productTitle = productTypeElement.textContent || '';
          var productUrl = ((_productTypeElement$c = productTypeElement.closest('a')) === null || _productTypeElement$c === void 0 ? void 0 : _productTypeElement$c.href) || '';

          // You might need to adjust this logic based on your product naming conventions
          if (productTitle.toLowerCase().includes('pharmacy') || productUrl.includes('pharmacy')) {
            productType = 'Pharmacy';
          } else if (productTitle.toLowerCase().includes('prescription') || productUrl.includes('prescription')) {
            productType = 'Prescription';
          }
        }

        // Add badge if product type is detected
        if (productType) {
          var detailsElement = cartItem.querySelector('.cart-item__details');
          if (detailsElement) {
            var badgeContainer = document.createElement('div');
            badgeContainer.className = 'cart-item__badge-container';

            // Define product type arrays to match the logic used in other parts of the codebase
            var pharmacyTypes = ['pharmacy medication', 'dummy consultation', 'prescription with exemption'];
            var prescriptionTypes = ['prescription medication', 'dummy consultation'];
            var productTypeLower = productType.toLowerCase();

            // Check if product type matches pharmacy types
            var isPharmacyProduct = pharmacyTypes.some(type => productTypeLower === type.toLowerCase());

            // Check if product type matches prescription types
            var isPrescriptionProduct = prescriptionTypes.some(type => productTypeLower === type.toLowerCase());
            if (isPrescriptionProduct) {
              badgeContainer.innerHTML = "\n                <span class=\"badge--prescription tw-flex tw-items-center tw-pl-s tw-pr-s tw-flex-row tw-gap-xxs tw-px-s tw-rounded-s tw-text-headingS tw-leading-snug tw-bg-secondary-200 tw-text-secondary-700 tw-font-medium tw-w-fit tw-h-fit\" aria-hidden=\"true\">\n                  <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"13\" viewBox=\"0 0 14 13\" fill=\"none\">\n                    <g clip-path=\"url(#clip0_3658_6707)\">\n                      <path d=\"M11.968 6.82781L11.1079 6.00335L8.49567 8.50125L6.66999 6.75732C7.79225 6.30678 8.60757 5.23713 8.60757 4.02343C8.60757 2.43887 7.21673 1.15161 5.50935 1.15161H2.41113V9.94482H3.62932V6.98412H5.18642L7.63558 9.32571L5.02656 11.8205L5.88664 12.645L8.49886 10.1471L11.1111 12.645L11.9712 11.8205L9.36215 9.32571L11.968 6.82781ZM3.62932 5.81333V2.31627H5.50935C6.54529 2.31627 7.38939 3.0825 7.38939 4.02036C7.38939 4.99194 6.5293 5.81333 5.50935 5.81333H3.62932Z\" fill=\"#075F68\"/>\n                    </g>\n                    <defs>\n                      <clipPath id=\"clip0_3658_6707\">\n                        <rect width=\"13\" height=\"12\" fill=\"white\" transform=\"translate(0.485352 0.690063)\"/>\n                      </clipPath>\n                    </defs>\n                  </svg>\n                  Prescription\n                </span>\n              ";
            } else if (isPharmacyProduct) {
              badgeContainer.innerHTML = "\n                <span class=\"badge--pharmacy tw-flex tw-items-center tw-pl-s tw-pr-s tw-flex-row tw-gap-xxs tw-px-s tw-rounded-s tw-text-headingS tw-leading-snug tw-bg-tertiary-100 tw-text-tertiary-500 tw-font-medium tw-w-fit tw-h-fit\" aria-hidden=\"true\">\n                  <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"13\" height=\"13\" viewBox=\"0 0 13 13\" fill=\"none\">\n                    <g clip-path=\"url(#clip0_3225_13147)\">\n                      <circle cx=\"6.48499\" cy=\"6.69006\" r=\"5.5\" stroke=\"#2D3A55\"/>\n                      <path d=\"M6.48499 3.69006V9.69006\" stroke=\"#2D3A55\"/>\n                      <path d=\"M3.48499 6.69006L9.48499 6.69006\" stroke=\"#2D3A55\"/>\n                    </g>\n                    <defs>\n                      <clipPath id=\"clip0_3225_13147\">\n                        <rect width=\"12\" height=\"12\" fill=\"white\" transform=\"translate(0.484985 0.690063)\"/>\n                      </clipPath>\n                    </defs>\n                  </svg>\n                  Pharmacy\n                </span>\n              ";
            }

            // Insert badge at the beginning of details element
            if (badgeContainer.innerHTML.trim()) {
              detailsElement.insertBefore(badgeContainer, detailsElement.firstChild);
              console.log("Added ".concat(productType, " badge to cart item ").concat(index + 1));
            }
          }
        }
      });
      console.log('Product badges display check completed');
    } catch (error) {
      console.error('Error ensuring product badges display:', error);
    }
  }

  /**
   * Check if a product is an appointment product (doctor or pharmacist consultation)
   * @param {Object} product - Product data
   * @returns {Object} Object with isAppointment and priority (doctor > pharmacist)
   */
  isAppointmentProduct(product) {
    if (!product) return {
      isAppointment: false,
      priority: 0
    };

    // Check if product type is Service
    var productType = product.product_type || '';
    var isService = productType.toLowerCase() === 'service';

    // Check for appointment type in properties (for newly added items)
    var appointmentType = product.properties && product.properties._appointment_type;
    if (appointmentType) {
      return {
        isAppointment: true,
        priority: appointmentType === 'doctor' ? 2 : appointmentType === 'pharmacist' ? 1 : 0,
        type: appointmentType
      };
    }
    if (isService) {
      // For existing items without properties, determine type from title
      var productTitle = product.title || '';
      var isDoctor = productTitle.toLowerCase().includes('doctor') || productTitle.toLowerCase().includes('physician');
      var isPharmacist = productTitle.toLowerCase().includes('pharmacist') || productTitle.toLowerCase().includes('pharmacy');
      return {
        isAppointment: true,
        priority: isDoctor ? 2 : isPharmacist ? 1 : 0,
        // Doctor has highest priority
        type: isDoctor ? 'doctor' : isPharmacist ? 'pharmacist' : 'other'
      };
    }
    return {
      isAppointment: false,
      priority: 0
    };
  }

  /**
   * Check if a product is a prescription product
   * @param {Object} product - Product data
   * @returns {boolean} True if product is prescription-related
   */
  isPrescriptionProduct(product) {
    if (!product) return false;

    // Exclude consultation products (Service product type)
    var productType = product.product_type || '';
    var isService = productType.toLowerCase() === 'service';
    if (isService) {
      return false; // Exclude consultation products
    }

    // Check for prescription product type
    var isPrescription = productType.toLowerCase() === 'prescription medication';

    // Check for dummy consultation type (should be detected as prescription)
    var isDummyConsultation = productType.toLowerCase() === 'dummy consultation';
    return isPrescription || isDummyConsultation;
  }

  /**
   * Check if a product is a pharmacy product
   * @param {Object} product - Product data
   * @returns {boolean} True if product is pharmacy-related
   */
  isPharmacyProduct(product) {
    if (!product) return false;

    // Exclude consultation products (Service product type)
    var productType = product.product_type || '';
    var isService = productType.toLowerCase() === 'service';
    if (isService) {
      return false; // Exclude consultation products
    }

    // Check for pharmacy product types
    var isPharmacyMedication = productType.toLowerCase() === 'pharmacy medication';
    var isPrescriptionWithExemption = productType.toLowerCase() === 'prescription with exemption';

    // Check for dummy consultation type (should be detected as pharmacy)
    var isDummyConsultation = productType.toLowerCase() === 'dummy consultation';
    return isPharmacyMedication || isPrescriptionWithExemption || isDummyConsultation;
  }

  /**
   * Check if a dummy consultation product already exists in the cart
   * @returns {Promise<boolean>} True if dummy consultation exists in cart
   */
  checkDummyConsultationInCart() {
    var _this0 = this;
    return (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* () {
      try {
        var cart = yield _this0.fetchCart();
        var dummyConsultationExists = cart.items.some(item => {
          var productType = item.product_type || '';
          return productType.toLowerCase() === 'dummy consultation';
        });
        return dummyConsultationExists;
      } catch (error) {
        console.error('Error checking for dummy consultation in cart:', error);
        return false;
      }
    })();
  }

  /**
   * Clear conflicting consultation form data based on current cart contents
   * @param {Array} cartItems - Current cart items
   */
  clearConflictingConsultationFormDataFromCart(cartItems) {
    try {
      // Access the form store if available
      if (!window.formStore) {
        console.log('Form store not accessible, skipping form data clearing');
        return;
      }
      var formStoreState = window.formStore.getState();
      var {
        form
      } = formStoreState;
      if (!form || !form.setFormValues) {
        console.log('Form store methods not available, skipping form data clearing');
        return;
      }

      // Analyze cart for consultation products
      var hasDoctorConsultation = false;
      var hasPharmacyConsultation = false;
      cartItems.forEach(item => {
        if (item.properties && item.properties._appointment_type) {
          var appointmentType = item.properties._appointment_type;
          if (appointmentType === 'doctor') {
            hasDoctorConsultation = true;
          } else if (appointmentType === 'pharmacist') {
            hasPharmacyConsultation = true;
          }
        }
      });

      // Clear conflicting form data based on cart contents
      if (hasDoctorConsultation && hasPharmacyConsultation) {
        // If both exist, keep doctor (higher priority) and clear pharmacy
        form.setFormValues('pharmacistConsultation', null);
        form.setFormValues('pharmacistConsultation', null, 'verificationForm');
        console.log('Both consultation types found, cleared pharmacy consultation data (doctor takes priority)');
      } else if (hasDoctorConsultation) {
        // Only doctor consultation, clear pharmacy data
        form.setFormValues('pharmacistConsultation', null);
        form.setFormValues('pharmacistConsultation', null, 'verificationForm');
        console.log('Doctor consultation found, cleared pharmacy consultation data');
      } else if (hasPharmacyConsultation) {
        // Only pharmacy consultation, clear doctor data
        form.setFormValues('doctorConsultation', null);
        form.setFormValues('doctorConsultation', null, 'verificationForm');
        console.log('Pharmacy consultation found, cleared doctor consultation data');
      } else {
        // No consultation products, clear both
        form.setFormValues('pharmacistConsultation', null);
        form.setFormValues('pharmacistConsultation', null, 'verificationForm');
        form.setFormValues('doctorConsultation', null);
        form.setFormValues('doctorConsultation', null, 'verificationForm');
        console.log('No consultation products found, cleared all consultation form data');
      }
    } catch (error) {
      console.error('Error clearing conflicting consultation form data from cart:', error);
    }
  }

  /**
   * Get consultation step information from form lists
   * @param {string} productType - Product type (Prescription or Pharmacy)
   * @returns {Object} Consultation step info
   */
  getConsultationStepInfo(productType) {
    var prescriptionFormList = [{
      id: "userInfo",
      step: 0
    }, {
      id: "informationForm",
      step: 1
    }, {
      id: "verificationForm",
      step: 2,
      formList: [{
        id: "verifyPrescription",
        step: 0
      }, {
        id: "uploadPrescription",
        step: 1
      }, {
        id: "pharmacistConsultation",
        step: 2
      }, {
        id: "doctorConsultation",
        step: 3
      }]
    }, {
      id: "healthCheck",
      step: 3
    }];
    var pharmacyFormList = [{
      id: "userInfo",
      step: 0
    }, {
      id: "informationForm",
      step: 1
    }, {
      id: "pharmacistConsultation",
      step: 2
    }, {
      id: "healthCheck",
      step: 3
    }];
    var formList = productType === 'Prescription' ? prescriptionFormList : pharmacyFormList;

    // Find consultation step
    if (productType === 'Prescription') {
      var verificationForm = formList.find(form => form.id === 'verificationForm');
      if (verificationForm && verificationForm.formList) {
        var doctorConsultation = verificationForm.formList.find(form => form.id === 'doctorConsultation');
        var pharmacistConsultation = verificationForm.formList.find(form => form.id === 'pharmacistConsultation');
        return {
          mainStep: verificationForm.step,
          doctorStep: doctorConsultation ? doctorConsultation.step : null,
          pharmacistStep: pharmacistConsultation ? pharmacistConsultation.step : null,
          parentFormId: 'verificationForm'
        };
      }
    } else {
      var _pharmacistConsultation = formList.find(form => form.id === 'pharmacistConsultation');
      return {
        mainStep: _pharmacistConsultation ? _pharmacistConsultation.step : null,
        doctorStep: null,
        pharmacistStep: _pharmacistConsultation ? _pharmacistConsultation.step : null,
        parentFormId: null
      };
    }
    return {
      mainStep: null,
      doctorStep: null,
      pharmacistStep: null,
      parentFormId: null
    };
  }

  /**
   * Auto-move to consultation step if current step is beyond consultation step
   * @param {Array} cartItems - Current cart items
   */
  autoMoveToConsultationStep(cartItems) {
    try {
      // Determine product type from cart
      var productType = 'None';
      for (var item of cartItems) {
        if (this.isPrescriptionProduct(item)) {
          productType = 'Prescription';
          break;
        } else if (this.isPharmacyProduct(item)) {
          productType = 'Pharmacy';
          break;
        }
      }
      if (productType === 'None') {
        return; // No prescription or pharmacy products
      }

      // Get consultation step info
      var consultationInfo = this.getConsultationStepInfo(productType);
      if (!consultationInfo.mainStep) {
        return; // No consultation step found
      }

      // Check if form store is available
      if (!window.useFormStore) {
        console.log('Form store not available for auto-move to consultation step');
        return;
      }
      var {
        form,
        nestedForm
      } = window.useFormStore.getState();
      var currentStep = parseInt(form.currentStep);

      // Check if current step is beyond consultation step
      if (currentStep > consultationInfo.mainStep) {
        console.log("Auto-moving to consultation step: current step ".concat(currentStep, " > consultation step ").concat(consultationInfo.mainStep));

        // Move to consultation step
        form.setCurrentStep(consultationInfo.mainStep);

        // If it's a nested form, set the appropriate sub-step
        if (consultationInfo.parentFormId) {
          // For prescription flow, determine which consultation type to show
          var hasDoctorAppointment = cartItems.some(item => {
            var appointmentInfo = this.isAppointmentProduct(item);
            return appointmentInfo.isAppointment && appointmentInfo.type === 'doctor';
          });
          var hasPharmacistAppointment = cartItems.some(item => {
            var appointmentInfo = this.isAppointmentProduct(item);
            return appointmentInfo.isAppointment && appointmentInfo.type === 'pharmacist';
          });
          if (hasDoctorAppointment && consultationInfo.doctorStep !== null) {
            nestedForm.setCurrentStep(consultationInfo.parentFormId, consultationInfo.doctorStep);
            console.log("Moved to doctor consultation step: ".concat(consultationInfo.doctorStep));
          } else if (hasPharmacistAppointment && consultationInfo.pharmacistStep !== null) {
            nestedForm.setCurrentStep(consultationInfo.parentFormId, consultationInfo.pharmacistStep);
            console.log("Moved to pharmacist consultation step: ".concat(consultationInfo.pharmacistStep));
          } else {
            // Default to pharmacist consultation if no appointment exists
            nestedForm.setCurrentStep(consultationInfo.parentFormId, consultationInfo.pharmacistStep);
            console.log("Moved to default pharmacist consultation step: ".concat(consultationInfo.pharmacistStep));
          }
        }
      }
    } catch (error) {
      console.error('Error auto-moving to consultation step:', error);
    }
  }

  /**
   * Trigger auto-removal of orphaned appointments by fetching cart first
   */
  triggerAutoRemoveOrphanedAppointments() {
    var _this1 = this;
    return (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* () {
      console.log('=== TRIGGER AUTO-REMOVAL CALLED ===');
      try {
        console.log('Fetching cart for auto-removal...');
        var cart = yield _this1.fetchCart();
        console.log('Cart fetched, calling autoRemoveOrphanedAppointments...');
        yield _this1.autoRemoveOrphanedAppointments(cart.items);
        console.log('Auto-removal completed');
      } catch (error) {
        console.error('Error triggering auto-removal of orphaned appointments:', error);
      }
    })();
  }

  /**
   * Auto-remove appointment products when related product types are removed
   * @param {Array} cartItems - Current cart items
   * @param {Function} onSuccess - Callback function called with result
   * @param {Function} onError - Callback function called with error
   */
  autoRemoveOrphanedAppointments(cartItems, onSuccess, onError) {
    var _this10 = this;
    return (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* () {
      try {
        var appointmentItems = [];
        var prescriptionProducts = [];
        var pharmacyProducts = [];
        console.log('=== AUTO-REMOVAL DEBUG ===');
        console.log('All cart items:', cartItems);

        // Categorize cart items
        for (var item of cartItems) {
          console.log("Checking item: ".concat(item.title));
          console.log("  - Tags:", item.tags);
          console.log("  - Product type:", item.product_type);
          console.log("  - Properties:", item.properties);
          var appointmentInfo = _this10.isAppointmentProduct(item);
          if (appointmentInfo.isAppointment) {
            console.log("  - Is appointment: YES (".concat(appointmentInfo.type, ")"));
            appointmentItems.push({
              item: item,
              info: appointmentInfo
            });
          } else {
            console.log("  - Is appointment: NO");
          }
          if (_this10.isPrescriptionProduct(item)) {
            console.log("  - Is prescription: YES");
            prescriptionProducts.push(item);
          } else {
            console.log("  - Is prescription: NO");
          }
          if (_this10.isPharmacyProduct(item) || window.shopifyCustomer.isForeigner || window.isPrescriptionAppointmentValid) {
            console.log("  - Is pharmacy: YES");
            pharmacyProducts.push(item);
          } else {
            console.log("  - Is pharmacy: NO");
          }
          console.log('---');
        }
        console.log('Categorized items:');
        console.log('  - Appointment items:', appointmentItems.length);
        console.log('  - Prescription products:', prescriptionProducts.length);
        console.log('  - Pharmacy products:', pharmacyProducts.length);
        if (appointmentItems.length === 0) {
          // No appointment products to check
          if (onSuccess) onSuccess({
            removedItems: []
          });
          return {
            removedItems: []
          };
        }
        var removedItems = [];

        // Check each appointment product - only remove those with _appointment_type property
        for (var appointmentItem of appointmentItems) {
          // Only process appointment products that have the _appointment_type property
          var hasAppointmentTypeProperty = appointmentItem.item.properties && appointmentItem.item.properties._appointment_type;
          if (!hasAppointmentTypeProperty) {
            console.log("Skipping appointment product without _appointment_type property: ".concat(appointmentItem.item.title));
            continue;
          }
          var shouldRemove = false;
          var reason = '';
          if (appointmentItem.info.type === 'doctor') {
            // Doctor appointments require prescription products
            console.log("Checking doctor appointment: prescriptionProducts.length = ".concat(prescriptionProducts.length));
            if (prescriptionProducts.length === 0) {
              shouldRemove = true;
              reason = 'no_prescription_products';
              console.log("Doctor appointment should be removed: no prescription products found");
            } else {
              console.log("Doctor appointment should NOT be removed: ".concat(prescriptionProducts.length, " prescription products found"));
            }
          } else if (appointmentItem.info.type === 'pharmacist') {
            // Pharmacist appointments require pharmacy products
            console.log("Checking pharmacist appointment: pharmacyProducts.length = ".concat(pharmacyProducts.length));
            if (pharmacyProducts.length === 0) {
              shouldRemove = true;
              reason = 'no_pharmacy_products';
              console.log("Pharmacist appointment should be removed: no pharmacy products found");
            } else {
              console.log("Pharmacist appointment should NOT be removed: ".concat(pharmacyProducts.length, " pharmacy products found"));
            }
          }
          console.log('shouldRemove', shouldRemove);
          console.log('reason', reason);
          console.log('appointmentItem', appointmentItem);
          console.log('prescriptionProducts', prescriptionProducts);
          console.log('pharmacyProducts', pharmacyProducts);
          if (shouldRemove) {
            console.log("Auto-removing ".concat(appointmentItem.info.type, " appointment (with _appointment_type property): ").concat(reason));
            yield _this10.removeFromCart(appointmentItem.item.key);
            removedItems.push({
              item: appointmentItem.item,
              reason: reason
            });
          }
        }
        if (removedItems.length > 0) {
          console.log("Auto-removed ".concat(removedItems.length, " orphaned appointment products with _appointment_type property"));
        }

        // Auto-move to consultation step if needed
        _this10.autoMoveToConsultationStep(cartItems);
        if (onSuccess) onSuccess({
          removedItems
        });
        return {
          removedItems
        };
      } catch (error) {
        console.error('Error auto-removing orphaned appointments:', error);
        if (onError) onError(error);
        throw error;
      }
    })();
  }

  /**
   * Remove other appointment products when adding a new one (doctor takes priority)
   * @param {Object} newProduct - New product being added
   * @param {Function} onSuccess - Callback function called with result
   * @param {Function} onError - Callback function called with error
   */
  handleAppointmentProductPriority(newProduct, onSuccess, onError) {
    var _this11 = this;
    return (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* () {
      try {
        var newProductInfo = _this11.isAppointmentProduct(newProduct);
        if (!newProductInfo.isAppointment) {
          // Not an appointment product, proceed normally
          if (onSuccess) onSuccess({
            action: 'none',
            removedItems: []
          });
          return {
            action: 'none',
            removedItems: []
          };
        }
        console.log("Adding appointment product: ".concat(newProductInfo.type, " (priority: ").concat(newProductInfo.priority, ")"));

        // Get current cart
        var cart = yield _this11.fetchCart();
        var appointmentItems = [];

        // Find existing appointment products
        for (var item of cart.items) {
          var itemInfo = _this11.isAppointmentProduct(item);
          if (itemInfo.isAppointment) {
            appointmentItems.push({
              item: item,
              info: itemInfo
            });
          }
        }
        if (appointmentItems.length === 0) {
          // No existing appointment products, proceed normally
          if (onSuccess) onSuccess({
            action: 'none',
            removedItems: []
          });
          return {
            action: 'none',
            removedItems: []
          };
        }

        // Check if we need to remove existing appointment products
        var highestExistingPriority = Math.max(...appointmentItems.map(item => item.info.priority));
        if (newProductInfo.priority > highestExistingPriority) {
          // New product has higher priority, remove all existing appointment products
          console.log("New appointment product has higher priority (".concat(newProductInfo.priority, " > ").concat(highestExistingPriority, "), removing existing appointment products"));
          var removedItems = [];
          for (var appointmentItem of appointmentItems) {
            yield _this11.removeFromCart(appointmentItem.item.key);
            removedItems.push(appointmentItem.item);
            console.log("Removed appointment product: ".concat(appointmentItem.info.type));
          }
          if (onSuccess) onSuccess({
            action: 'replaced',
            removedItems
          });
          return {
            action: 'replaced',
            removedItems
          };
        } else if (newProductInfo.priority === highestExistingPriority) {
          // Same priority, check if it's the same type
          var sameTypeItem = appointmentItems.find(item => item.info.type === newProductInfo.type);
          if (sameTypeItem) {
            // Same type, update existing item instead of adding new one
            console.log("Same appointment type already exists, updating existing item");
            if (onSuccess) onSuccess({
              action: 'update',
              removedItems: []
            });
            return {
              action: 'update',
              removedItems: []
            };
          } else {
            // Different type but same priority, remove existing and add new
            console.log("Different appointment type with same priority, replacing existing");
            var _removedItems = [];
            for (var _appointmentItem of appointmentItems) {
              yield _this11.removeFromCart(_appointmentItem.item.key);
              _removedItems.push(_appointmentItem.item);
            }
            if (onSuccess) onSuccess({
              action: 'replaced',
              removedItems: _removedItems
            });
            return {
              action: 'replaced',
              removedItems: _removedItems
            };
          }
        } else {
          // New product has lower priority, don't add it
          console.log("New appointment product has lower priority (".concat(newProductInfo.priority, " < ").concat(highestExistingPriority, "), not adding"));
          if (onSuccess) onSuccess({
            action: 'blocked',
            removedItems: []
          });
          return {
            action: 'blocked',
            removedItems: []
          };
        }
      } catch (error) {
        console.error('Error handling appointment product priority:', error);
        if (onError) onError(error);
        throw error;
      }
    })();
  }

  /**
   * Add item to cart with properties and refresh cart section
   * @param {Object} itemData - Item data to add
   * @param {string} sectionId - Section ID to refresh
   * @param {Function} onSuccess - Callback function called with response
   * @param {Function} onError - Callback function called with error
   */
  addToCartAndRefresh(itemData, sectionId, onSuccess, onError) {
    var _this12 = this;
    return (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* () {
      try {
        // Check appointment product priority before adding
        var priorityResult = yield _this12.handleAppointmentProductPriority(itemData, result => {
          console.log('Appointment priority check result:', result);
        }, error => {
          console.error('Appointment priority check error:', error);
        });

        // If blocked, don't add the product
        if (priorityResult.action === 'blocked') {
          var error = new Error('Cannot add appointment product with lower priority');
          if (onError) onError(error);
          throw error;
        }

        // If update action, update existing item instead of adding new one
        if (priorityResult.action === 'update') {
          // Find existing item and update it
          var cart = yield _this12.fetchCart();
          var existingItem = cart.items.find(item => {
            var itemInfo = _this12.isAppointmentProduct(item);
            return itemInfo.isAppointment && itemInfo.type === _this12.isAppointmentProduct(itemData).type;
          });
          if (existingItem) {
            // Update existing item with new properties
            var updateResult = yield _this12.updateCartItemPropertiesAndRefresh(existingItem.key, itemData.properties || {}, sectionId, onSuccess, onError);
            return updateResult;
          }
        }

        // Normal add to cart
        var addResult = yield _this12.addToCart([itemData]);
        if (sectionId) {
          yield _this12.refreshCartSection(sectionId);
        }
        if (onSuccess) {
          onSuccess(addResult);
        }
        return addResult;
      } catch (error) {
        console.error('Error adding to cart and refreshing:', error);
        if (onError) {
          onError(error);
        }
        throw error;
      }
    })();
  }

  /**
   * Update cart item properties and refresh cart section
   * @param {string} itemKey - Cart item key
   * @param {Object} properties - Properties to update
   * @param {string} sectionId - Section ID to refresh
   * @param {Function} onSuccess - Callback function called with response
   * @param {Function} onError - Callback function called with error
   */
  updateCartItemPropertiesAndRefresh(itemKey, properties, sectionId, onSuccess, onError) {
    var _this13 = this;
    return (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* () {
      try {
        var updateResult = yield _this13.updateCartItemProperties(itemKey, properties);
        if (sectionId) {
          yield _this13.refreshCartSection(sectionId);
        }
        if (onSuccess) {
          onSuccess(updateResult);
        }
        return updateResult;
      } catch (error) {
        console.error('Error updating cart item properties and refreshing:', error);
        if (onError) {
          onError(error);
        }
        throw error;
      }
    })();
  }

  /**
   * Refresh the whole cart - updates all cart sections and triggers necessary events
   * @param {Function} onSuccess - Callback function called with success
   * @param {Function} onError - Callback function called with error
   * @param {Object} options - Additional options for refresh
   * @param {boolean} options.refreshSections - Whether to refresh cart sections (default: true)
   * @param {boolean} options.triggerEvents - Whether to trigger cart update events (default: true)
   * @param {boolean} options.updateVisibility - Whether to update cart form visibility (default: true)
   * @param {Array} options.sectionIds - Specific section IDs to refresh (default: auto-detect)
   */
  refreshWholeCart(onSuccess, onError) {
    var _arguments2 = arguments,
      _this14 = this;
    return (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* () {
      var options = _arguments2.length > 2 && _arguments2[2] !== undefined ? _arguments2[2] : {};
      try {
        var {
          refreshSections = true,
          triggerEvents = true,
          updateVisibility = true,
          sectionIds = null
        } = options;
        console.log('Refreshing whole cart with options:', options);

        // Step 1: Fetch latest cart data
        var cart = yield _this14.fetchCart();

        // Step 2: Update cart token globally
        window.cartToken = cart.token;

        // Perform normal cart refresh
        yield _this14.performCartRefresh(cart, onSuccess, onError, options);
      } catch (error) {
        console.error('Error refreshing whole cart:', error);
        if (onError) {
          onError(error);
        }
        throw error;
      }
    })();
  }

  /**
   * Perform the actual cart refresh operations
   * @param {Object} cart - Cart data
   * @param {Function} onSuccess - Callback function called with refreshed cart data
   * @param {Function} onError - Callback function called with error
   * @param {Object} options - Additional options for refresh behavior
   */
  performCartRefresh(cart, onSuccess, onError) {
    var _arguments3 = arguments,
      _this15 = this;
    return (0,_babel_runtime_helpers_asyncToGenerator__WEBPACK_IMPORTED_MODULE_0__["default"])(function* () {
      var options = _arguments3.length > 3 && _arguments3[3] !== undefined ? _arguments3[3] : {};
      try {
        var {
          refreshSections = true,
          triggerEvents = true,
          updateVisibility = true,
          sectionIds = null
        } = options;

        // Update cart token globally
        window.cartToken = cart.token;

        // Refresh cart sections if enabled
        if (refreshSections) {
          var sectionsToRefresh = sectionIds || _this15.detectCartSections();
          if (sectionsToRefresh.length === 0) {
            console.warn('No cart sections found to refresh');
          } else {
            for (var sectionId of sectionsToRefresh) {
              try {
                yield _this15.refreshCartSection(sectionId);
                console.log("Refreshed cart section: ".concat(sectionId));
              } catch (sectionError) {
                console.warn("Failed to refresh section ".concat(sectionId, ":"), sectionError);
              }
            }
          }
        }

        // Trigger cart update events if enabled
        if (triggerEvents) {
          _this15.triggerCartEvents(cart);
        }

        // Update cart form visibility if enabled
        if (updateVisibility) {
          window.updateCartFormVisibility(cart.items);
        }

        // Update cart gifts status if enabled
        if (updateVisibility && window.updateCartGiftsStatus) {
          window.updateCartGiftsStatus(cart);
        }

        // Update cart gifts banner status if enabled
        if (updateVisibility && window.updateCartGiftsBannerStatus) {
          window.updateCartGiftsBannerStatus(cart);
        }

        // Update cart items element classes and header count
        _this15.updateCartItemsClasses(cart);
        console.log('Cart header count updated during whole cart refresh');

        // Update subtotal display to ensure it reflects current cart state
        _this15.updateCartSubtotalDisplay(cart);
        console.log('Subtotal updated during whole cart refresh');
        if (onSuccess) {
          onSuccess(cart);
        }
        return cart;
      } catch (error) {
        console.error('Error during cart refresh operations:', error);
        if (onError) {
          onError(error);
        }
        throw error;
      }
    })();
  }

  /**
   * Detect cart sections that need to be refreshed
   * @returns {Array} Array of section IDs
   */
  detectCartSections() {
    var sections = [];

    // Common cart section IDs
    var commonSections = ['main-cart-items', 'cart-items', 'cart-drawer', 'cart-totals', 'cart-count', 'cart-icon-bubble'];

    // Check for sections that exist in the DOM
    commonSections.forEach(sectionId => {
      var element = document.querySelector("#".concat(sectionId));
      if (element) {
        sections.push(sectionId);
        console.log("Found cart section: ".concat(sectionId));
      }
    });

    // Also check for sections with data-section-id attribute
    var sectionElements = document.querySelectorAll('[data-section-id]');
    sectionElements.forEach(element => {
      var sectionId = element.getAttribute('data-section-id');
      if (sectionId && !sections.includes(sectionId)) {
        sections.push(sectionId);
        console.log("Found cart section with data-section-id: ".concat(sectionId));
      }
    });
    console.log("Detected ".concat(sections.length, " cart sections:"), sections);
    return sections;
  }

  /**
   * Trigger cart update events
   * @param {Object} cart - Cart data
   */
  triggerCartEvents(cart) {
    // Trigger custom cart update event
    var cartUpdateEvent = new CustomEvent('cartUpdate', {
      detail: {
        cart: cart,
        source: 'shopify-cart-operations',
        timestamp: new Date().toISOString()
      }
    });
    document.dispatchEvent(cartUpdateEvent);

    // Trigger cart form update event
    var cartFormUpdateEvent = new CustomEvent('cartFormUpdate', {
      detail: {
        cart: cart
      }
    });
    document.dispatchEvent(cartFormUpdateEvent);
    console.log('Cart events triggered');
  }

  /**
   * Update cart subtotal display directly
   * @param {Object} cart - Cart data
   */
  updateCartSubtotalDisplay(cart) {
    var subtotalElements = document.querySelectorAll('.totals__subtotal-value');
    if (subtotalElements.length > 0 && cart && cart.total_price !== undefined) {
      // Use Shopify's money formatting to match the site's currency
      var formattedPrice;
      if (window.theme && window.theme.moneyFormat) {
        // Use Shopify's money format (e.g., "${{amount}}" or "SGD ${{amount}}")
        formattedPrice = window.theme.moneyFormat.replace('{{amount}}', (cart.total_price / 100).toFixed(2));

        // If the format doesn't include currency code, add it manually
        if (!formattedPrice.includes('SGD') && !formattedPrice.includes('USD') && !formattedPrice.includes('EUR')) {
          formattedPrice = formattedPrice + ' SGD';
        }
      } else {
        // Fallback: try to detect currency from existing elements to preserve money format
        var existingElement = subtotalElements[0];
        if (existingElement && existingElement.textContent) {
          // Extract currency symbol and format from existing text to maintain consistency
          var existingText = existingElement.textContent;
          var currencyMatch = existingText.match(/^[^\d]*/);
          var currencySymbol = currencyMatch ? currencyMatch[0] : '$';
          formattedPrice = currencySymbol + (cart.total_price / 100).toFixed(2);

          // Add currency code if not present
          if (!formattedPrice.includes('SGD') && !formattedPrice.includes('USD') && !formattedPrice.includes('EUR')) {
            formattedPrice = formattedPrice + ' SGD';
          }
        } else {
          // Final fallback - preserve default currency format
          formattedPrice = '$' + (cart.total_price / 100).toFixed(2) + ' SGD';
        }
      }

      // Update all subtotal elements while preserving the money format
      subtotalElements.forEach((element, index) => {
        element.textContent = formattedPrice;
      });
    } else {
      console.log('updateCartSubtotalDisplay: No elements found or invalid cart data');
    }
  }

  /**
   * Update cart form visibility based on cart contents
   * @param {Object} cart - Cart data
   */
  updateCartFormVisibility(cart) {
    if (window.updateCartFormVisibility) {
      window.updateCartFormVisibility(cart.items);
    }
  }

  /**
   * Check customer login status using the same logic as the global function
   * @returns {boolean} Whether customer is logged in
   */
  checkCustomerLoginStatus() {
    return window.CustomerData && window.CustomerData.isLoggedIn;
  }

  /**
   * Update cart items element classes
   * @param {Object} cart - Cart data
   */
  updateCartItemsClasses(cart) {
    // Update cart-items element classes
    var cartItemsElement = document.querySelector('cart-items');
    if (cartItemsElement) {
      cartItemsElement.classList.toggle('is-empty', cart.item_count === 0);
    }

    // Update cart drawer classes
    var cartDrawerElement = document.querySelector('.cart-drawer');
    if (cartDrawerElement) {
      cartDrawerElement.classList.toggle('is-empty', cart.item_count === 0);
    }

    // Update cart count elements
    var cartCountElements = document.querySelectorAll('.cart-count, [data-cart-count]');
    cartCountElements.forEach(element => {
      element.textContent = cart.item_count;
      element.setAttribute('data-cart-count', cart.item_count);
    });

    // Update cart icon bubble count (handle all cart count bubbles on the page)
    var cartCountBubbles = document.querySelectorAll('.cart-count-bubble');
    console.log('Found cart count bubbles:', cartCountBubbles.length);
    cartCountBubbles.forEach((bubbleContainer, index) => {
      var countSpan = bubbleContainer.querySelector('span[aria-hidden="true"]');
      console.log("Bubble ".concat(index, ":"), bubbleContainer, 'Count span:', countSpan);
      if (countSpan) {
        if (cart.item_count === 0) {
          // Hide the bubble when cart is empty
          bubbleContainer.style.display = 'none';
          console.log("Hidden bubble ".concat(index, " - cart is empty"));
        } else {
          // Show the bubble and update count
          bubbleContainer.style.display = 'block';
          countSpan.textContent = cart.item_count;
          console.log("Updated bubble ".concat(index, " with count:"), cart.item_count);
        }
      } else {
        console.log("No count span found in bubble ".concat(index));
      }
    });

    // Use global cart count update function if available
    if (window.updateCartCount) {
      window.updateCartCount(cart.item_count);
    }
    console.log('Cart element classes updated');
  }
}

// Create singleton instance
var shopifyCartOperations = new ShopifyCartOperations();

// Export for use in other files
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (shopifyCartOperations);

// Also make it available globally for backward compatibility
if (typeof window !== 'undefined') {
  window.shopifyCartOperations = shopifyCartOperations;
}

/***/ })

}]);